<template>
  <div class="ruleDetail">
    <div v-html="html"></div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      shopId: "",
      html: ""
    };
  },
  created() {
    this.shopId = this.$route.query.shopId;
    this.getPointsRule();
  },
  methods: {
    getPointsRule() {
      const params = {
        shopId: this.shopId
      };
      this.$store.dispatch("shop/shopPoints/getPointsRule", this.$qs.stringify(params)).then((data) => {
        document.title = data.name;
        this.html = this.formatRichText(data.rule);
      }).catch(() => {
      });
    },
    // 处理图片样式
    formatRichText(html) {
      if (!html) {
        return "";
      }
      // eslint-disable-next-line
      const newContent = html.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;"');
      console.log(newContent);
      return newContent;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import './style.scss';
</style>
